<div class="min-h-screen bg-[#F8FAFC] pb-24 text-slate-800">

    <!-- Top Breadcrumb & Hero Header -->
    <header
        class="bg-gradient-to-r from-[#151745] via-[#202367] to-[#102B51] text-white pt-24 pb-16 px-6 sm:px-10 lg:px-16 relative overflow-hidden">
        <!-- Ambient decorative elements -->
        <div class="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none"></div>
        <div class="absolute -bottom-10 left-10 w-72 h-72 bg-emerald-500/10 rounded-full blur-2xl pointer-events-none">
        </div>
        <div class="max-w-6xl mx-auto relative z-10">
            <!-- Hero Title -->
            <div class="max-w-3xl mx-auto text-center">
                <h1 class="text-2xl sm:text-4xl md:text-5xl font-black tracking-tight leading-tight text-white mb-4">
                    Formulir Pemesanan <br class="hidden sm:inline">
                    <span class="text-emerald-400">
                        Buku Tamu Digital
                    </span>
                </h1>
                <p class="text-sm sm:text-base text-slate-300 leading-relaxed font-light max-w-2xl mx-auto">
                    Sistem registrasi & absensi tamu modern berbasis QR Code kilat, live display ucapan layar LED,
                    souvenir scanner anti-duplikasi, serta rekap data kehadiran real-time.
                </p>
            </div>
        </div>
    </header>

    <!-- Main Content Container -->
    <main class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-20">

        <!-- 1. Package Selector Tabs -->
        <section class="bg-white rounded-3xl p-4 sm:p-6 md:p-8 shadow-xl border border-slate-100 mb-8">
            <div
                class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 border-b border-slate-100 pb-5">
                <div>
                    <h2 class="text-lg sm:text-xl font-black text-[#102B51]">
                        1. Pilih Paket & Add-on Buku Tamu
                    </h2>
                    <p class="text-xs sm:text-sm text-slate-500 mt-0.5">
                        Pilih paket layanan yang paling sesuai dengan kebutuhan venue dan konsep acara Anda.
                    </p>
                </div>
                <div class="flex items-center gap-2">
                    <span class="text-xs font-semibold text-slate-500">Pilihan Aktif:</span>
                    <span class="text-xs font-extrabold text-[#202367] bg-slate-100 px-3 py-1 rounded-full">
                        {{ getSelectedPackage()?.name || 'Memuat...' }}
                    </span>
                </div>
            </div>

            <!-- Dynamic Package Selection Cards -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div *ngFor="let pkg of packages; let idx = index" (click)="selectPackage(pkg.id)"
                    class="relative rounded-2xl p-6 sm:p-7 border-2 transition-all duration-300 cursor-pointer flex flex-col justify-between"
                    [ngClass]="selectedPackageId === pkg.id 
                        ? 'border-[#202367] bg-blue-50/30 shadow-lg ring-2 ring-[#202367]/20 scale-[1.01]' 
                        : 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md'">

                    <div>
                        <!-- Header & Badge -->
                        <div class="flex items-start justify-between gap-3 mb-4">
                            <div>
                                <span *ngIf="pkg.badge"
                                    class="text-[10px] font-extrabold uppercase px-2.5 py-1 rounded-full bg-[#202367] text-white">
                                    {{ pkg.badge }}
                                </span>
                                <h3 class="text-xl font-bold text-[#102B51] mt-2">
                                    {{ pkg.name }}
                                </h3>
                            </div>
                            <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors"
                                [ngClass]="selectedPackageId === pkg.id ? 'border-[#202367] bg-[#202367]' : 'border-slate-300 bg-white'">
                                <svg *ngIf="selectedPackageId === pkg.id" class="w-3.5 h-3.5 text-white" fill="none"
                                    stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                        d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        </div>

                        <!-- Price -->
                        <div class="mb-4">
                            <span class="text-[11px] text-slate-400 font-medium block">Mulai dari</span>
                            <div class="text-2xl sm:text-3xl font-black text-[#202367]">
                                {{ pkg.priceFormatted }}
                            </div>
                            <div *ngIf="pkg.regularPrice && pkg.regularPrice > pkg.price"
                                class="text-xs text-slate-400 line-through">
                                {{ cartService.formatCurrency(pkg.regularPrice) }}
                            </div>
                        </div>

                        <!-- Features Checklist -->
                        <ul *ngIf="pkg.features.length > 0"
                            class="space-y-2.5 text-xs text-slate-700 border-t border-slate-100 pt-4 mb-4">
                            <li *ngFor="let feat of pkg.features" class="flex items-start gap-2">
                                <svg class="w-4 h-4 text-[#202367] shrink-0 mt-0.5" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                        d="M5 13l4 4L19 7" />
                                </svg>
                                <span>{{ feat }}</span>
                            </li>
                        </ul>
                    </div>

                    <div *ngIf="pkg.crew"
                        class="mt-4 pt-3 border-t border-slate-100/60 flex items-center justify-between text-xs text-slate-500">
                        <span class="font-semibold text-slate-700">Crew Support:</span>
                        <span>{{ pkg.crew }}</span>
                    </div>
                </div>

                <!-- Loading State -->
                <div *ngIf="isLoading && packages.length === 0" class="col-span-full text-center py-12">
                    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-[#202367] mx-auto mb-4"></div>
                    <p class="text-slate-500 text-sm">Memuat paket...</p>
                </div>

                <!-- Empty State -->
                <div *ngIf="!isLoading && packages.length === 0" class="col-span-full text-center py-12">
                    <p class="text-slate-500 text-sm">Belum ada paket tersedia</p>
                </div>
            </div>

            <div class="mt-8 border-t border-slate-200 pt-6 sm:pt-8">
                <div class="mb-5">
                    <h3 class="text-base sm:text-lg font-black text-[#102B51]">
                        Tambahkan Add-on <span class="text-xs font-semibold text-slate-400">(Opsional)</span>
                    </h3>
                    <p class="text-xs sm:text-sm text-slate-500 mt-1">
                        Tambahkan fasilitas ekstra untuk paket yang dipilih. Biayanya langsung masuk ke total pesanan.
                    </p>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div *ngFor="let addon of addons" (click)="toggleAddon(addon)"
                        class="p-4 rounded-xl border-2 transition-all cursor-pointer flex items-start justify-between gap-3"
                        [ngClass]="addon.selected 
                        ? 'border-[#202367] bg-blue-50/40 shadow-sm' 
                        : 'border-slate-200 hover:border-slate-300 bg-slate-50/50'">

                        <div class="flex items-start gap-3">
                            <input type="checkbox" [checked]="addon.selected" (change)="toggleAddon(addon)"
                                class="mt-1 w-4 h-4 rounded text-[#202367] focus:ring-[#202367] border-gray-300 cursor-pointer pointer-events-none">
                            <div>
                                <h4 class="text-xs sm:text-sm font-bold text-[#102B51]">
                                    {{ addon.name }}
                                </h4>
                                <p class="text-[11px] text-slate-500 mt-0.5 leading-snug">
                                    {{ addon.description }}
                                </p>
                            </div>
                        </div>

                        <div class="text-right shrink-0">
                            <span class="text-xs sm:text-sm font-bold text-[#202367]">
                                +{{ addon.priceFormatted }}
                            </span>
                        </div>
                    </div>
                </div>


            </div>
        </section>

        <!-- 3. Form Pemesanan & Order Summary (2 Columns) -->
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <!-- cek -->
            <!-- LEFT FORM COLUMN (lg:col-span-7) -->
            <section id="booking-form"
                class="lg:col-span-7 bg-white rounded-3xl p-6 sm:p-8 shadow-xl border border-slate-100 space-y-5">
                <div class="border-b border-slate-100 pb-4">
                    <h2 class="text-lg sm:text-xl font-black text-[#102B51]">
                        3. Informasi Pemesan & Detail Acara
                    </h2>
                    <p class="text-xs sm:text-sm text-slate-500 mt-0.5">
                        Lengkapi formulir di bawah ini agar tim Visidea dapat memverifikasi jadwal & venue acara Anda.
                    </p>
                </div>

                <form class="space-y-4" (ngSubmit)="submitOrder()">
                    <!-- Nama Pemesan -->
                    <div>
                        <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                            Nama Lengkap Pemesan / Penyelenggara <span class="text-red-500">*</span>
                        </label>
                        <input type="text" [(ngModel)]="customerName" name="customerName"
                            placeholder="Contoh: Johan Prasetya"
                            class="w-full px-4 py-2.5 rounded-xl border text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]"
                            [ngClass]="formSubmitted && !customerName.trim() ? 'border-red-400 bg-red-50/20' : 'border-slate-200 bg-slate-50/30 focus:bg-white'">
                        <p *ngIf="formSubmitted && !customerName.trim()" class="text-[11px] text-red-500 mt-1">
                            Nama pemesan wajib diisi.
                        </p>
                    </div>

                    <!-- Nomor WhatsApp & Email -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                No. WhatsApp (Aktif) <span class="text-red-500">*</span>
                            </label>
                            <input type="tel" [value]="customerPhone" (input)="onPhoneInput($event)"
                                name="customerPhone" placeholder="082260084847"
                                class="w-full px-4 py-2.5 rounded-xl border text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]"
                                [ngClass]="formSubmitted && !customerPhone.trim() ? 'border-red-400 bg-red-50/20' : 'border-slate-200 bg-slate-50/30 focus:bg-white'">
                            <p *ngIf="formSubmitted && !customerPhone.trim()" class="text-[11px] text-red-500 mt-1">
                                Nomor WhatsApp wajib diisi.
                            </p>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Alamat Email (Opsional)
                            </label>
                            <input type="email" [(ngModel)]="customerEmail" name="customerEmail"
                                placeholder="johan@gmail.com"
                                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/30 focus:bg-white text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]">
                        </div>
                    </div>

                    <!-- Nama Acara & Jenis Acara -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Nama Acara / Pasangan <span class="text-red-500">*</span>
                            </label>
                            <input type="text" [(ngModel)]="eventName" name="eventName"
                                placeholder="The Wedding of Johan & Rara"
                                class="w-full px-4 py-2.5 rounded-xl border text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]"
                                [ngClass]="formSubmitted && !eventName.trim() ? 'border-red-400 bg-red-50/20' : 'border-slate-200 bg-slate-50/30 focus:bg-white'">
                            <p *ngIf="formSubmitted && !eventName.trim()" class="text-[11px] text-red-500 mt-1">
                                Nama acara wajib diisi.
                            </p>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Jenis Acara <span class="text-red-500">*</span>
                            </label>
                            <select [(ngModel)]="eventType" name="eventType"
                                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/30 focus:bg-white text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]">
                                <option value="Wedding">Pernikahan (Wedding)</option>
                                <option value="Birthday / Sweet 17">Ulang Tahun / Sweet 17</option>
                                <option value="Corporate Event / Gathering">Corporate Gathering / Event Perusahaan
                                </option>
                                <option value="Seminar / Conference">Seminar / Conference</option>
                                <option value="Reuni / Wisuda">Reuni / Wisuda</option>
                                <option value="Acara Lainnya">Acara Lainnya</option>
                            </select>
                        </div>
                    </div>

                    <!-- Tanggal Acara & Estimasi Tamu -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Tanggal Acara <span class="text-red-500">*</span>
                            </label>
                            <input type="date" [(ngModel)]="eventDate" name="eventDate"
                                class="w-full px-4 py-2.5 rounded-xl border text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]"
                                [ngClass]="formSubmitted && !eventDate.trim() ? 'border-red-400 bg-red-50/20' : 'border-slate-200 bg-slate-50/30 focus:bg-white'">
                            <p *ngIf="formSubmitted && !eventDate.trim()" class="text-[11px] text-red-500 mt-1">
                                Tanggal acara wajib dipilih.
                            </p>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Estimasi Jumlah Tamu
                            </label>
                            <select [(ngModel)]="estimatedGuests" name="estimatedGuests"
                                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/30 focus:bg-white text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]">
                                <option value="< 100 Tamu">
                                    < 100 Tamu (Intimate Event)</option>
                                <option value="100 - 300 Tamu">100 - 300 Tamu</option>
                                <option value="300 - 600 Tamu">300 - 600 Tamu</option>
                                <option value="600 - 1000 Tamu">600 - 1000 Tamu</option>
                                <option value="> 1000 Tamu">> 1000 Tamu (Grand Event)</option>
                            </select>
                        </div>
                    </div>

                    <!-- Lokasi / Venue Acara -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Kota Acara
                            </label>
                            <input type="text" [(ngModel)]="eventCity" name="eventCity"
                                placeholder="Contoh: Jakarta / Bandung"
                                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/30 focus:bg-white text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                                Nama Gedung / Lokasi Venue <span class="text-red-500">*</span>
                            </label>
                            <input type="text" [(ngModel)]="eventVenue" name="eventVenue"
                                placeholder="Contoh: Ballroom Hotel Mulia"
                                class="w-full px-4 py-2.5 rounded-xl border text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367]"
                                [ngClass]="formSubmitted && !eventVenue.trim() ? 'border-red-400 bg-red-50/20' : 'border-slate-200 bg-slate-50/30 focus:bg-white'">
                            <p *ngIf="formSubmitted && !eventVenue.trim()" class="text-[11px] text-red-500 mt-1">
                                Nama lokasi venue wajib diisi.
                            </p>
                        </div>
                    </div>

                    <!-- Catatan Tambahan -->
                    <div>
                        <label class="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">
                            Catatan Khusus / Permintaan Tambahan (Opsional)
                        </label>
                        <textarea [(ngModel)]="notes" name="notes" rows="2"
                            placeholder="Tuliskan permintaan khusus seperti jam loading in, dress code crew, atau integrasi khusus..."
                            class="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-slate-50/30 focus:bg-white text-xs sm:text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#202367] resize-none"></textarea>
                    </div>
                </form>
            </section>

            <!-- RIGHT SUMMARY & SUBMIT COLUMN (lg:col-span-5) -->
            <aside class="lg:col-span-5 space-y-6 sticky top-6">

                <!-- Order Summary Card -->
                <div class="bg-white rounded-3xl p-6 sm:p-7 shadow-xl border border-slate-100">
                    <h3
                        class="text-base sm:text-lg font-black text-[#102B51] border-b border-slate-100 pb-4 mb-4 flex items-center justify-between">
                        <span>Ringkasan Pesanan</span>
                        <span class="text-xs font-bold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full">
                            Draft Order
                        </span>
                    </h3>

                    <!-- Selected Package Detail -->
                    <div class="flex items-center gap-3 p-3.5 rounded-2xl bg-slate-50 border border-slate-100 mb-4">
                        <div class="flex-1 min-w-0">
                            <h4 class="font-extrabold text-sm text-[#102B51] truncate">
                                {{ getSelectedPackage().name }}
                            </h4>
                            <p class="text-[11px] text-slate-500 truncate">
                                {{ getSelectedPackage().crew }}
                            </p>
                            <span class="text-xs font-black text-[#202367]">
                                {{ getSelectedPackage().priceFormatted }}
                            </span>
                        </div>
                    </div>

                    <!-- Add-ons breakdown if any -->
                    <div *ngIf="calculateAddonsTotal() > 0" class="border-t border-slate-100 pt-3 mb-3 space-y-2">
                        <span class="text-[11px] font-bold text-slate-500 uppercase tracking-wider block mb-1">
                            {{ getSelectedAddonsCount() }} add-on terpilih:
                        </span>
                        <ng-container *ngFor="let a of addons">
                            <div *ngIf="a.selected" class="flex items-center justify-between text-xs text-slate-600">
                                <span class="truncate pr-2">• {{ a.name }}</span>
                                <span class="font-bold shrink-0">+{{ a.priceFormatted }}</span>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Total Price Calculation -->
                    <div class="border-t-2 border-slate-100 pt-4 mb-6 space-y-2">
                        <div class="flex justify-between items-center text-xs text-slate-500">
                            <span>Harga Paket</span>
                            <span class="font-semibold text-slate-800">{{ getSelectedPackage().priceFormatted }}</span>
                        </div>
                        <div *ngIf="calculateAddonsTotal() > 0"
                            class="flex justify-between items-center text-xs text-slate-500">
                            <span>Biaya Add-ons</span>
                            <span class="font-semibold text-slate-800">+Rp {{
                                calculateAddonsTotal().toLocaleString('id-ID') }}</span>
                        </div>
                        <div class="flex justify-between items-baseline pt-2 border-t border-dashed border-slate-200">
                            <span class="text-sm font-bold text-[#102B51]">Total Biaya</span>
                            <span class="text-2xl font-black text-emerald-600">
                                Rp {{ calculateGrandTotal().toLocaleString('id-ID') }}
                            </span>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <button (click)="submitOrder()"
                        class="w-full py-3.5 px-6 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 active:scale-[0.99] text-white font-black text-sm transition-all duration-200 shadow-lg shadow-emerald-500/25 flex items-center justify-center gap-2 cursor-pointer mb-3">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span>Masukkan ke Keranjang</span>
                    </button>

                    <p class="text-[11px] text-center text-slate-400">
                        Paket dan add-on pilihan Anda akan masuk ke keranjang untuk melanjutkan pemesanan.
                    </p>
                </div>

                <!-- Visidea Service Guarantee Box -->
                <div
                    class="bg-gradient-to-br from-[#102B51] to-[#202367] rounded-3xl p-6 text-white shadow-lg space-y-3">
                    <h4 class="font-black text-sm tracking-wide text-amber-200 flex items-center gap-1.5">
                        <span>JAMINAN LAYANAN VISIDEA</span>
                    </h4>
                    <ul class="space-y-2 text-xs text-slate-200 font-light">
                        <li class="flex items-start gap-2">
                            <span class="text-emerald-400 font-bold">✓</span>
                            <span>Setup & brief teknis H-1 sebelum acara</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-emerald-400 font-bold">✓</span>
                            <span>Sistem Offline Sync (Aman dari kendala sinyal venue)</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-emerald-400 font-bold">✓</span>
                            <span>Crew standby profesional & berpengalaman</span>
                        </li>
                    </ul>
                </div>

            </aside>

        </div>

    </main>

</div>